import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui';

interface LandingCtaProps {
  onFindCandidatesClick?: () => void;
}

// Anasayfa (Roadmap v9) tasarımındaki "Kalemi bize bırak" bölümü; footer'dan ayrı, açık zemin üzerinde bir kart.
export const LandingCta = ({ onFindCandidatesClick }: LandingCtaProps) => {
  const { t } = useTranslation();

  return (
    <section className='mx-auto max-w-[1280px] px-4 pb-24 font-[Geist,ui-sans-serif,system-ui,sans-serif] md:px-6'>
      <div className='grid items-center gap-10 overflow-hidden rounded-[28px] bg-footer px-6 py-14 text-footer-text md:px-[58px] lg:grid-cols-[540px_1fr]'>
        <div>
          <h2 className='m-0 font-[Newsreader,serif] text-[40px] font-normal leading-[1.04] tracking-[-.02em] text-footer-heading md:text-[56px]'>
            {t('landingPage.cta.titleLine1')}
            <br />
            <i className='text-footer-link-hover'>{t('landingPage.cta.titleLine2')}</i>
          </h2>
          <p className='mt-[22px] max-w-[470px] text-base leading-[1.55] text-footer-text'>
            {t('landingPage.cta.description')}
          </p>
          <div className='mt-[26px] flex flex-wrap gap-3'>
            <Button
              type='button'
              className='h-12 rounded-[10px] bg-footer-heading px-[22px] text-[15px] font-medium text-footer hover:bg-white active:bg-footer-heading'
            >
              {t('landingPage.cta.seekJobs')} ↗
            </Button>
            <Button
              type='button'
              variant='outline'
              onClick={onFindCandidatesClick}
              className='h-12 rounded-[10px] border-footer-muted bg-transparent px-[22px] text-[15px] font-medium text-footer-heading hover:bg-footer-heading/10 hover:text-footer-heading'
            >
              {t('landingPage.cta.findCandidates')} ↗
            </Button>
          </div>
        </div>

        {/* Ekip görseli — tasarımdaki 390px yüksekliğindeki görsel alanına sığar */}
        <div aria-hidden='true' className='mx-auto hidden h-[390px] flex-col items-center justify-center lg:flex'>
          <img
            src='/landing/roadmap-v9/cta-ekip-v2.webp'
            alt=''
            loading='lazy'
            decoding='async'
            className='h-[380px] w-[380px]'
          />
        </div>
      </div>
    </section>
  );
};
